class FormularioPersonaReadDto {
  public id: number;
  public mail: string;
  public code: string;
  public status: string;
  public lastStep: number;
}

export default FormularioPersonaReadDto;
